export default __webpack_public_path__ + "static/media/temperature-okay.93d19147.svg";